import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { SectionHeader } from './SectionHeader';

interface FormSectionProps {
  title: string | ReactNode;
  children: ReactNode;
}

/**
 * Labeled form section with a title header and stacked children.
 */
export function FormSection({ title, children }: FormSectionProps) {
  return (
    <Box mb={4}>
      <SectionHeader title={title} />
      <Stack spacing={4}>{children}</Stack>
    </Box>
  );
}
